import { render, staticRenderFns } from "./BindTipsDialog.vue?vue&type=template&id=32bb97c3&scoped=true"
import script from "./BindTipsDialog.vue?vue&type=script&lang=js"
export * from "./BindTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./BindTipsDialog.vue?vue&type=style&index=0&id=32bb97c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bb97c3",
  null
  
)

export default component.exports